import { AbsTipoUtente } from "./AbsTipoUtente";

export class TipoUtente extends AbsTipoUtente {
    

}